import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

// Firebaseの設定
const firebaseConfig = {
  apiKey: "AIzaSyAQ1nDjQuNpwKweGI9pkbR0S_38eZgvwCY",
  authDomain: "miyazaki-quiz-power-spot.firebaseapp.com",
  projectId: "miyazaki-quiz-power-spot",
  storageBucket: "miyazaki-quiz-power-spot.firebasestorage.app",
  messagingSenderId: "953749403459",
  appId: "1:953749403459:web:b165ada464c222f7aa21f6"
};

// Firebaseの初期化
const app = initializeApp(firebaseConfig);

// Firestoreのインスタンスを取得
export const db = getFirestore(app);
